import { clientRecords } from '@atheneum/api'
import { extendObservable } from 'mobx'
import remove from 'lodash/remove'

class ProjectsListingStore {
  constructor () {
    extendObservable(this, {
      loading: null,
      error: null,
      total: null,
      query: this.getEmptyQuery(),
      accounts: [],
      projectDetails: []
    })
  }

  setQuery (query) {
    this.query = {
      ...this.getEmptyQuery(),
      ...query
    }
  }

  getEmptyQuery () {
    return {
      status: [],
      page: 1
    }
  }

  loadAccounts (parentAccountId) {
    return clientRecords
      .getAccounts(parentAccountId, { expanded: false })
      .then(accounts => {
        this.accounts = accounts
      })
  }

  filter (query) {
    this.setQuery(query)

    this.loading = true
    this.total = null

    clientRecords
      .getProjects(this.query)
      .then(res => {
        this.total = res.hits.total
        let projects = res.hits.hits.map(hit => {
          return hit._source
        })
        this.projectDetails.replace(projects)
      })
      .catch(err => {
        this.error = err
      })
      .then(() => {
        this.loading = false
      })
  }

  changeStatus (status, value) {
    if (value) {
      this.query.status.push(status)
    } else {
      remove(this.query.status, n => status === n)
    }
    this.filter(this.query)
  }

  changePage (page) {
    this.filter({ page, ...this.query })
  }
}

export default ProjectsListingStore
